var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-widget"},[_c('div',{staticClass:"fill",style:(_vm.background)}),_vm._v(" "),_c('div',{staticClass:"score"}),_vm._v(" "),_c('div',{staticClass:"display"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }